module.exports = __webpack_public_path__ + "media/images/flags/16/Bolivia-df6675be752976b049cbacff16111e4d.png";